<script>
	export let articleData;
	const baseUrl = 'https://dcpapers.dublincore.org';
	const pdfUrl = `${baseUrl}/files/articles/${articleData.id}/dcmi-${articleData.id}.pdf`;
	const keywords = articleData.keywords?.length ? articleData.keywords.join('; ') : '';
</script>

<svelte:head>
	<meta name="citation_title" content={articleData.title} />
	<meta name="citation_doi" content={articleData.doi} />
	<meta name="citation_abstract_html_url" content={baseUrl + '/article/' + articleData.id} />
	<meta name="citation_abstract" content={articleData.abstract} />
	<meta name="citation_fulltext_html_url" content={baseUrl + '/article/' + articleData.id} />

	{#if articleData.authors && articleData.authors.length > 0}
		{#each articleData.authors as author}
			<meta
				name="citation_author"
				content={`${author.first_name} ${author.middle_name ? author.middle_name + ' ' : ''}${author.last_name}`}
			/>
			{#if author.orcid}
				<meta name="citation_author_orcid" content={author.orcid} />
			{/if}
			{#if author.affiliation}
				<meta name="citation_author_institution" content={author.affiliation} />
			{/if}
		{/each}
	{/if}
	<meta name="citation_year" content={articleData.year} />
	<meta name="citation_publication_date" content={articleData.date_published} />
	<meta
		name="citation_journal_title"
		content="Proceedings of the International Conference on Dublin Core and Metadata Applications"
	/>
	<meta name="citation_journal_issn" content="1939-1366" />
	<meta name="citation_journal_eissn" content="1939-1366" />
	<meta name="citation_pdf_url" content={pdfUrl} />
	<meta name="citation_language" content="en" />
	{#if keywords}
		<meta name="citation_keywords" content={keywords} />
	{/if}
	<meta
		name="citation_conference_title"
		content="International Conference on Dublin Core and Metadata Applications"
	/>
	<meta name="citaion_public_url" content={baseUrl + '/article/' + articleData.id} />
</svelte:head>
